interface DataCategory {
  href: string;
}

export const dataCategories: DataCategory[] = [
  { href: "http://publications.europa.eu/resource/authority/data-theme/ENVI" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/ECON" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/EDUC" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/REGI" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/INTR" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/GOVE" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/ENER" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/JUST" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/HEAL" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/SOCI" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/AGRI" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/TRAN" },
  { href: "http://publications.europa.eu/resource/authority/data-theme/TECH" },
];
